import config from '../config';
import Logger from '../logger';
import event from '../mixins/event';

class ThemeHeader {

	// Vars
	// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

	/**
	 * Class constructor
	 */
	constructor(dom) {

		this.NAME = 'ThemeHeader';

		this.dom = dom;

		this.drawer = this.dom.querySelector('[data-theme-header-drawer]');
		this.drawerActiveClass = 'theme-header__drawer--active';
		this.toggleDrawerDoms = this.dom.querySelectorAll('[data-theme-header-toggle-drawer]');
		this.drawerSubMenuRadioDoms = this.dom.querySelectorAll('[data-theme-header-drawer-sub-menu-radio]');
		this.drawerSubMenuToggleDoms = this.dom.querySelectorAll('[data-theme-header-drawer-sub-menu-toggle]');
	}

	/**
	 * init - Initialize the component
	 **/
	init() {
		Logger.info(`${this.NAME} > init`);

		this.toggleDrawerDoms.forEach(toggleDrawerDom => {
			toggleDrawerDom.addEventListener('click', () => {
				this.toggleDrawer();
			});
		});

		this.drawerSubMenuToggleDoms.forEach(drawerSubMenuToggleDom => {
			drawerSubMenuToggleDom.addEventListener('click', () => {
				// Find the nearest .theme-header__drawer-menu-item parent, then search for .toggle-header-drawer-sub-menu
				const drawerSubMenuItemDom = drawerSubMenuToggleDom.closest('.theme-header__drawer-menu-item');
				if (drawerSubMenuItemDom) {
					const drawerSubMenuRadioDom = drawerSubMenuItemDom.querySelector('[data-theme-header-drawer-sub-menu-radio]');
					if (drawerSubMenuRadioDom) {
						// Toggle the radio
						drawerSubMenuRadioDom.checked = !drawerSubMenuRadioDom.checked;
					}
				}
			});
		});
	}

	/**
	 * hideDrawer - Hide the drawer
	 */
	hideDrawer() {
		this.drawer.classList.remove(this.drawerActiveClass);
		this.drawerSubMenuRadioDoms.forEach(drawerSubMenuRadioDom => {
			drawerSubMenuRadioDom.checked = false;
		});
		window.dispatchEvent(new CustomEvent('body-scroll:stop'));
	}

	/**
	 * showDrawer - Show the drawer
	 */
	showDrawer() {
		this.drawer.classList.add(this.drawerActiveClass);
		window.dispatchEvent(new CustomEvent('body-scroll:start'));
	}

	/**
	 * toggleDrawer - Toggle the drawer
	 */
	toggleDrawer() {
		if (this.drawer.classList.contains(this.drawerActiveClass)) {
			this.hideDrawer();
		} else {
			this.showDrawer();
		}
	}


}

Object.assign(ThemeHeader.prototype, event);

export default ThemeHeader;
